import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { defineIntegration } from '../integration.js';
import { relative, basename } from '../utils-hoist/path.js';
import { GLOBAL_OBJ } from '../utils-hoist/worldwide.js';
var INTEGRATION_NAME = 'RewriteFrames';

/**
 * Rewrite event frames paths.
 */
var rewriteFramesIntegration = defineIntegration(function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var root = options.root;
  var prefix = options.prefix || 'app:///';
  var isBrowser = 'window' in GLOBAL_OBJ && GLOBAL_OBJ.window !== undefined;
  var iteratee = options.iteratee || generateIteratee({
    isBrowser: isBrowser,
    root: root,
    prefix: prefix
  });

  /** Process an exception event. */
  function _processExceptionsEvent(event) {
    try {
      return _objectSpread(_objectSpread({}, event), {}, {
        exception: _objectSpread(_objectSpread({}, event.exception), {}, {
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(function (value) {
            return _objectSpread(_objectSpread({}, value), value.stacktrace && {
              stacktrace: _processStacktrace(value.stacktrace)
            });
          })
        })
      });
    } catch (_oO) {
      return event;
    }
  }

  /** Process a stack trace. */
  function _processStacktrace(stacktrace) {
    return _objectSpread(_objectSpread({}, stacktrace), {}, {
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function (f) {
        return iteratee(f);
      })
    });
  }
  return {
    name: INTEGRATION_NAME,
    processEvent: function processEvent(originalEvent) {
      var processedEvent = originalEvent;
      if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
        processedEvent = _processExceptionsEvent(processedEvent);
      }
      return processedEvent;
    }
  };
});

/**
 * Exported only for tests.
 */
function generateIteratee(_ref) {
  var isBrowser = _ref.isBrowser,
    root = _ref.root,
    prefix = _ref.prefix;
  return function (frame) {
    if (!frame.filename) {
      return frame;
    }

    // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
    var isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) ||
    // or the presence of a backslash without a forward slash (which are not allowed on Windows)
    frame.filename.includes('\\') && !frame.filename.includes('/');

    // Check if the frame filename begins with `/`
    var startsWithSlash = /^\//.test(frame.filename);
    if (isBrowser) {
      if (root) {
        var oldFilename = frame.filename;
        if (oldFilename.indexOf(root) === 0) {
          frame.filename = oldFilename.replace(root, prefix);
        }
      }
    } else {
      if (isWindowsFrame || startsWithSlash) {
        var filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
        .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
        var base = root ? relative(root, filename) : basename(filename);
        frame.filename = "".concat(prefix).concat(base);
      }
    }
    return frame;
  };
}
export { generateIteratee, rewriteFramesIntegration };